const getValuesAndLabels = (
  propValueObject: Record<string, any>,
  key: string
) =>
  Object.keys(propValueObject || {}).map((valueOption) => ({
    value: valueOption,
    label: `apartment.${key}.${valueOption}`
  }))

// clientForm
const languages = [
  {
    value: 'fi',
    label: 'language.fi'
  },
  {
    value: 'en',
    label: 'language.en'
  }
]

// information form
const checkboxProperties = [
  {
    value: 'hasTerrace',
    label: 'apartment.additionalProperties.terrace'
  },
  {
    value: 'hasElevator',
    label: 'apartment.additionalProperties.elevator'
  },
  {
    value: 'internetIncluded',
    label: 'apartment.additionalProperties.internetIncluded'
  },
  {
    value: 'hasLaundromat',
    label: 'apartment.additionalProperties.laundromat'
  },
  {
    value: 'isFurnished',
    label: 'apartment.additionalProperties.furnished'
  },
  {
    value: 'hasOutdoorEquipmentStorage',
    label: 'apartment.additionalProperties.outdoorEquipmentStorage'
  },
  {
    value: 'groupsPossible',
    label: 'apartment.additionalProperties.groupsPossible'
  },
  {
    value: 'iggloGuarantee',
    label: 'apartment.additionalProperties.iggloGuarantee'
  }
]

export { getValuesAndLabels, checkboxProperties, languages }
